import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const FetchCurrentUser = graphql(`
    query FetchCurrentUser {
        currentUser {
            user {
                ... on BaseUser {
                    ...CurrentUser
                }
            }
            activeRole {
                ... on RoleAssignment {
                    ...RoleAssignment
                }
            }
        }
    }
`);

export const CurrentUser = graphql(`
    fragment CurrentUser on BaseUser {
        ... on TenantUser {
            __typename
            id
            email
            name
            isSuperAdmin
            firstName
            lastName
            has2FASetup
            aboutVideoWatched
            language
            company {
                id
                name
            }
            roleAssignments {
                role
                assignedGroups {
                    groupId
                    group {
                        id
                        name
                    }
                    subGroupIds
                    subGroups {
                        id
                        name
                    }
                    buddyIds
                    buddies {
                        ... on BaseUser {
                            id
                            name
                        }
                    }
                }
            }
        }
        ... on SuperAdminUser {
            __typename
            id
            email
            name
            isSuperAdmin
            firstName
            lastName
            has2FASetup
            aboutVideoWatched
            language
        }
    }
`);

const RoleAssignment = graphql(`
    fragment RoleAssignment on RoleAssignment {
        role
        assignedGroups {
            groupId
            group {
                id
                name
            }
            subGroupIds
            subGroups {
                id
                name
            }
            buddyIds
            buddies {
                ... on BaseUser {
                    id
                    name
                    firstName
                    lastName
                }
            }
        }
    }
`);

type CurrentUserFragment = ResultOf<typeof CurrentUser>;
export type TenantUserDataFragment = Extract<CurrentUserFragment, { __typename: 'TenantUser' }>;
export type SuperAdminUserDataFragment = Extract<CurrentUserFragment, { __typename: 'SuperAdminUser' }>;
